(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  const faqItems = document.querySelectorAll("[data-faq]");

  // Step 1: Make the first FAQ active by default
  if (faqItems.length > 0) {
    faqItems[0].classList.add("active");
  }

  // Step 2: Add click listeners with close-others logic
  faqItems.forEach(item => {
    item.querySelector(".faq-question").addEventListener("click", () => {
      // Close all other FAQ items
      faqItems.forEach(faq => faq.classList.remove("active"));

      // Open the clicked one
      item.classList.add("active");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["satisfied_clients_testimonial"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.testimonial-swiper', {
  loop: false,
  slidesPerView: 2,
  spaceBetween: 30,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    0: { slidesPerView: 1 },
    768: { slidesPerView: 2 }
  }
});

  } catch(e) { console.error(e); }
})();
})();
